// Local
// export const API_URL = 'http://localhost:3301/';

import moment from "moment";
import PizZip from "pizzip";
import { SUB_ADMIN, SUPER_ADMIN } from "./roles";

// production
export const API_URL = process.env.REACT_APP_HOSTURL;
// export const API_URL = 'http://18.236.155.96:3301/';
// export const API_URL = 'http://54.187.90.102:3301/';

// job status
export const JOB_STATUS_OPEN = 'Open';
export const JOB_STATUS_ON_HOLD = 'On Hold';
export const JOB_STATUS_CLOSED = 'Closed';

// this is interviewer status it will be update by employee to accept and reject interviewer
export const PROPOSED_INTERVIEWER_STATUS_PENDING = "";
export const PROPOSED_INTERVIEWER_STATUS_APPROVE = "APPROVE";
export const PROPOSED_INTERVIEWER_STATUS_REJECT = "REJECT";

// interview schedule status its schedule or now
export const SCHEDULER_STATUS_PENDING = 'SCHEDULER_STATUS_PENDING';
export const SCHEDULER_STATUS_DONE = 'SCHEDULER_STATUS_DONE';
export const SCHEDULER_STATUS_CANCELLED = 'SCHEDULER_STATUS_CANCELLED';

// candidate is selected or not
export const INTERVIEW_FINAL_STATUS_SELECTED = 'INTERVIEW_FINAL_STATUS_SELECTED';
export const INTERVIEW_FINAL_STATUS_REJECTED = 'INTERVIEW_FINAL_STATUS_REJECTED';

// qc status from superadmin or ralaadmin
export const QC_STATUS_PASS = 'QC_STATUS_PASS';
export const QC_STATUS_FAIL = 'QC_STATUS_FAIL';

// INCOMPLETE_OPTIONS
export const PROXY = "PROXY";
export const BANDWIDTH_ISSUE_CANDIDATE_END = "BANDWIDTH_ISSUE_CANDIDATE_END";
export const BANDWIDTH_ISSUE_INTERVIEWER_END = "BANDWIDTH_ISSUE_INTERVIEWER_END";
export const HARDWARE_ISSUE_CANDIDATE_END = "HARDWARE_ISSUE_CANDIDATE_END";
export const HARDWARE_ISSUE_INTERVIEWER_END = "HARDWARE_ISSUE_INTERVIEWER_END";
export const NO_SHOW_BY_INTERVIWER = "NO_SHOW_BY_INTERVIWER";
export const NO_SHOW_BY_CANDIDATE = "NO_SHOW_BY_CANDIDATE";


// user status
export const USER_STATUS_PENDING = 'PENDING';
export const USER_STATUS_APPROVE = 'APPROVE';
export const USER_STATUS_REJECT = 'REJECT';
export const USER_STATUS_ON_HOLD = 'ON_HOLD';

export const getUserStatus = (status) => {
    return status ? status.replaceAll("_", " ").replace(/\w+/g,
        function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }) : USER_STATUS_PENDING;
}

// pagination
export const ITEMS_PER_PAGE = 20;

export const getInterviewFinalStatus = (status) => {
    return status === INTERVIEW_FINAL_STATUS_SELECTED ? "Selected" : ((status === INTERVIEW_FINAL_STATUS_REJECTED) ? 'Rejected' : "")
}

export const getQCStatuslabel = (status) => {
    return status === "" ? "Pending" : (status === QC_STATUS_PASS ? "Qc Pass" : "Qc Fail");
}

export const getincompleteInterview = (status) => {
    return status.replaceAll("_", " ").replace(/(\w)(\w*)/g,
        function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
}
//previous_scheduled_on
// export const getSchedulerStatusLabel = (item) => {
//     return item.scheduler_status === SCHEDULER_STATUS_PENDING ? "Pending" : (
//         item.scheduler_status === SCHEDULER_STATUS_DONE ?
//             (item.previous_scheduled_on !== null ? 'Rescheduled' : 'Scheduled') :
//             'Cancelled'
//     );
// }

export const getSchedulerStatusLabel = (item) => {
    // console.log("item", item)
    const { scheduler_status, previous_scheduled_on } = item;
    // console.log("scheduler_status", scheduler_status)
    // console.log("previous_scheduled_on", previous_scheduled_on)
    if (scheduler_status === SCHEDULER_STATUS_PENDING) {
        return "Pending";
    }

    if (scheduler_status === SCHEDULER_STATUS_DONE) {
        return previous_scheduled_on !== null ? "Rescheduled" : "Scheduled";
    }

    return "Cancelled";
};


export const pascalCase = (words) => {
    return words.replace(/(\w)(\w*)/g, function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
}

export const updateStatusLabel = (status) => {
    return status === "APPROVE" ? "Approved" : (status === "REJECT" ? "Rejected" : (status === "ON_HOLD" ? "On Hold" : "Pending"));
}

export const commonDateFormat = (date, format = "") => {
    if (format === "") {
        return moment(date).format("DD/MM/YYYY h:mm A");
    } else {
        return moment(date).format(format);
    }
}

export const addAuthUserToSessionStorage = (user) => {
    sessionStorage.setItem(`user`, JSON.stringify(user));
    sessionStorage.setItem(`userToken`, user.token);
}

export const removeAuthUserFromSessionStorage = () => {
    sessionStorage.clear();
}

export const getAuthUserFromSessionStorage = () => {
    return JSON.parse(sessionStorage.getItem("user")) || null;
}

export const dayDifference = (dateString) => {
    const currentIstDate = moment().tz('Asia/Kolkata');
    const givenIstDate = moment.utc(dateString).tz('Asia/Kolkata');
    const differenceInDays = currentIstDate.diff(givenIstDate, 'days');
    return differenceInDays;
}

export const isToday = (dateString) => {
    const currentIstDate = moment().tz('Asia/Kolkata').startOf('day');
    const givenIstDate = moment.utc(dateString).tz('Asia/Kolkata').startOf('day');
    return currentIstDate.isSame(givenIstDate, 'day');
}

export const isFutureDate = (dateString) => {
    const currentIstDate = moment().tz('Asia/Kolkata').startOf('day');
    const givenIstDate = moment.utc(dateString).tz('Asia/Kolkata').startOf('day');
    const differenceInDays = givenIstDate.diff(currentIstDate, 'days');
    return differenceInDays > 0;
}

export const isDateGreaterThanToday = (dateString) => {
    const currentIstDate = moment().tz('Asia/Kolkata');
    const givenIstDate = moment.utc(dateString).tz('Asia/Kolkata');
    return givenIstDate.isAfter(currentIstDate);
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getRoleLabel = (role) => {
    return role === SUPER_ADMIN ? "Rala Super Admin" : role === SUB_ADMIN ? "Rala Sub Admin" : role.replaceAll("_", " ").replace(/\w+/g,
        function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
}

export const proposedInterviewerStatuslabel = {
    "APPROVE": "Approved",
    "REJECT": "Rejected",
    "": "Pending"
}

// export const allowedResumeTypes = [
//     'application/pdf',
//     'application/msword',
//     'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
// ];

export const allowedResumeTypes = [
    '.pdf',
    '.doc',
    '.docx',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const resumeFileTypeErrorMessage = "Please upload only pdf, doc, docx file";

export const allowedImageTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/webp',
    'image/svg+xml',
    'image/tiff'
];

export const imageFileTypeErrorMessage = "The selected file type is not allowed. Please select an image file.";

export const hasNumber = (myString) => {
    return /\d/.test(myString);
}

export const getFormattedDateTime = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');

    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1); // Month is 0-indexed
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());

    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};

let candidateName = ''
export const fileName = () => {
    //return moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    return candidateName + ' Feeback Report';
}

function parseText(text) {
    let name = "";
    let email = "";
    let phone = "";

    // Regex for phone number with labels like "Phone", "Mobile", or "Contact"
    let phoneRegex = /(?:Phone|Mobile|Contact):?\s*([\d\-\+\s\(\)]{7,15})/i;

    // Regex for name with label like "Name" or "Full Name"
    const nameMatch = text.match(/(?:Name|Full Name):?\s*([A-Za-z\s]+)/i);
    if (nameMatch && nameMatch[1]) {
        name = nameMatch[1].trim();
    } else {
        // Fallback regex for name without labels
        const fallbackNameRegex = /\b[A-Z][a-z]+\s[A-Z][a-z]+\b/g;
        const fallbackNameMatch = text.match(fallbackNameRegex);
        if (fallbackNameMatch && fallbackNameMatch.length > 0) {
            name = fallbackNameMatch[0].trim();
        }
    }

    // Extract phone number
    const phoneMatch = text.match(phoneRegex);
    if (phoneMatch && phoneMatch[1]) {
        phone = phoneMatch[1].trim();
    } else {
        // Fallback regex for phone number without labels
        phoneRegex =
            /(?:\+?\d{1,3}[\s-]?)?(?:\(?\d{2,3}\)?[\s-]?)?\d{3,4}[\s-]?\d{3,4}/g;
        const fallbackPhoneMatch = text.match(phoneRegex);
        if (fallbackPhoneMatch && fallbackPhoneMatch.length > 0) {
            phone = fallbackPhoneMatch[0].trim();
        }
    }

    // Remove "+91" if present in the phone number
    phone = phone.replace("+91", "").trim();

    // Extract email addresses
    const emailMatch = text.match(
        /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
    );
    if (emailMatch && emailMatch.length > 0) {
        email = emailMatch.join(", ");
    }

    return [name, email, phone];
}
export const extractPdfText = (file) => {
    return new Promise((resolve, reject) => {
        if (!file) {
            alert("Please select a PDF file.");
            return reject("No file selected.");
        }
        const reader = new FileReader();
        reader.onload = async function (event) {
            const uint8Array = new Uint8Array(event.target.result);
            const pdfDoc = window.pdfjsLib.getDocument(uint8Array);
            try {
                const pdf = await pdfDoc.promise;
                let extractedText = "";
                for (let pageIndex = 1; pageIndex <= pdf.numPages; pageIndex++) {
                    const page = await pdf.getPage(pageIndex);
                    const textContent = await page.getTextContent();
                    textContent.items.forEach((item) => {
                        extractedText += item.str + " ";
                    });
                }

                const [name, email, phone] = parseText(extractedText); // Replace with your `je` function logic
                resolve([name, email, phone]);
            } catch (error) {
                console.error("Error extracting text from PDF: ", error);
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
}

export const extractDocText = (file) => {
    return new Promise((resolve, reject) => {
        if (!file) {
            return reject("No file selected.");
        }
        const reader = new FileReader();
        reader.onload = async function (event) {
            const arrayBuffer = event.target.result;
            try {
                if (
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                ) {
                    const zip = await PizZip(arrayBuffer);
                    const documentXml = zip.file("word/document.xml").asText();
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(documentXml, "application/xml");
                    const textElements = xmlDoc.getElementsByTagName("w:t");
                    let extractedText = "";
                    for (let i = 0; i < textElements.length; i++) {
                        extractedText += textElements[i].textContent + " ";
                    }
                    const [name, email, phone] = parseText(extractedText); // Replace with your `je` function logic
                    resolve([name, email, phone]);
                } else if (file.type === "application/msword") {
                    const extractedText = (() => {
                        const uint8Array = new Uint8Array(arrayBuffer);
                        let text = "";
                        for (let i = 0; i < uint8Array.length; i++) {
                            if (uint8Array[i] >= 32 && uint8Array[i] <= 126) {
                                text += String.fromCharCode(uint8Array[i]);
                            }
                        }
                        return text;
                    })();
                    const [name, email, phone] = parseText(extractedText); // Replace with your `je` function logic
                    resolve([name, email, phone]);
                } else {
                    reject("Unsupported file type.");
                }
            } catch (error) {
                console.error("Error extracting text from DOCX: ", error);
                reject(error);
            }
        };

        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
}

const getRatingStatus = (rating) => {
    const ratingNumer = rating ? parseInt(rating) : 0;
    var ratingStatus = "";
    switch (ratingNumer) {
        case 0:
            ratingStatus = "Poor";
            break;
        case 1:
            ratingStatus = "Poor";
            break;
        case 2:
            ratingStatus = "Below-Average";
            break;
        case 3:
            ratingStatus = "Average";
            break;
        case 4:
            ratingStatus = "Good";
            break;
        case 5:
            ratingStatus = "Very good";
            break;
        default:
            break;
    }
    return ratingStatus;
}

const StarRating = (totalStars, filledStars) => {
    var startHtmlContent = "";
    for (var index = 0; index < totalStars; index++) {
        const starValue = index + 1;
        if (starValue <= filledStars) {
            startHtmlContent += `
                    <span style="color: gold; fontSize: 2em;">★</span>
                `;
        } else {
            startHtmlContent += `
                    <span style="color: grey; fontSize: 2em">★</span>
                `;
        }
    }
    return startHtmlContent;
};

const getPrimarySkillsUI = (interviewState) => {
    var UIHtmlContent = "";
    for (var index = 0; index < interviewState.primary_skill_feedback.length; index++) {
        var item = interviewState.primary_skill_feedback[index];
        var startHtmlContent = StarRating(5, item.rating);
        UIHtmlContent +=
            `<ul>
                <li><strong>${interviewState ? interviewState.job.primary_skill[index] : ""}</strong></li>
                <li>${startHtmlContent} <span class=${getRatingStatus(item.rating)}>${getRatingStatus(item.rating)}</span></li>
            </ul>
            <p>${item.review}</p>`;
    }
    return UIHtmlContent;
}

const getSecondarySkillsUI = (interviewState) => {
    var UIHtmlContent = "";
    for (var index = 0; index < interviewState.secondary_skill_feedback.length; index++) {
        var item = interviewState.secondary_skill_feedback[index];
        var startHtmlContent = StarRating(5, item.rating);
        UIHtmlContent +=
            `<ul>
                <li><strong>${interviewState ? interviewState.job.secondary_skill[index] : ""}</strong></li>
                <li>${startHtmlContent} <span class=${getRatingStatus(item.rating)}>${getRatingStatus(item.rating)}</span></li>
            </ul>
            <p>${item.review}</p>`;
    }
    return UIHtmlContent;
}

const getGoodToHaveSkillsUI = (interviewState) => {
    if (!interviewState.good_to_have_skill_feedback || interviewState.good_to_have_skill_feedback.trim() === "") return "";
    var UIHtmlContent = "";
    var startHtmlContent = StarRating(5, interviewState.good_to_have_skill_feedback_rating);
    UIHtmlContent +=
        `<ul>
            <li></li>
            <li>${startHtmlContent} <span class=${getRatingStatus(interviewState.good_to_have_skill_feedback_rating)}>${getRatingStatus(interviewState.good_to_have_skill_feedback_rating)}</span></li>
        </ul>
        <p>${interviewState.good_to_have_skill_feedback}</p>`;
    return UIHtmlContent;
}

const getCodingSkillsUI = (interviewState) => {
    if (!interviewState.coding_skill_feedback || interviewState.coding_skill_feedback.trim() === "") return "";
    var UIHtmlContent = "";
    var startHtmlContent = StarRating(5, interviewState.coding_skill_feedback_rating);
    UIHtmlContent +=
        `<ul>
            <li></li>
            <li>${startHtmlContent} <span class=${getRatingStatus(interviewState.coding_skill_feedback_rating)}>${getRatingStatus(interviewState.coding_skill_feedback_rating)}</span></li>
        </ul>
        <p>${interviewState.coding_skill_feedback}</p>`;
    return UIHtmlContent;
}

const getProfesstionalSkillsUI = (interviewState) => {
    var UIHtmlContent = "";
    candidateName = interviewState.candidate_name;
    for (var index in interviewState.professional_skill) {
        var item = interviewState.professional_skill[index];
        var startHtmlContent = StarRating(5, item.rating);
        if (item.enable && item.feedback && item.feedback.trim() !== '') {
            UIHtmlContent +=
                `<ul>
                <li><strong>${interviewState ? item.label : ""}</strong></li>
                <li>${startHtmlContent} <span class=${getRatingStatus(item.rating)}>${getRatingStatus(item.rating)}</span></li>
            </ul>
            <p>${item.feedback}</p>`;
        }
    }
    return UIHtmlContent;
}

const getUploadedScreenshotUI = (interviewState) => {
    var UIHtmlContent = "";
    for (var index = 0; index < interviewState.code_of_screenshot.length; index++) {
        // First 2 images should be full width, one by one
        const imageClass = index < 2 ? "screenshot-full-width" : "";
        UIHtmlContent +=
            `<img src="${process.env.REACT_APP_BUCKET_URL}${interviewState.code_of_screenshot[index]}" alt="Uploaded Screenshots" class="${imageClass}">`;
    }
    return UIHtmlContent;
}

const getCodingUI = (interviewState) => {
    var codeByCandidate = "";
    if (interviewState && interviewState.code_by_candidate) {
        codeByCandidate = `<SyntaxHighlighter style={solarizedlight}>${interviewState ? interviewState.code_by_candidate : ""}</SyntaxHighlighter>`
    }
    var codeOutputByCandidate = "";
    if (interviewState && interviewState.code_output_by_candidate) {
        codeOutputByCandidate = `<SyntaxHighlighter style={solarizedlight}>${interviewState ? interviewState.code_output_by_candidate : ""}</SyntaxHighlighter>`
    }
    return `<div class="coding_box">
            <div class="coding_child" style="background-color: #fdf6e3;">${codeByCandidate}</div>
            <div class="coding_child" style="background-color: #4d4033;color:#ffffff;">${codeOutputByCandidate}</div>
        </div>`;
}

const getOverallPercentageUI = (interviewState) => {
    if (!interviewState) return "";

    const total =
        (interviewState?.averagePrimarySkillsRating || 0) +
        (interviewState?.averageSecondarySkillsRating || 0) +
        (interviewState?.coding_skill_feedback_rating || 0) +
        (interviewState?.overall_rating || 0);

    const scoreOutOf10 = ((total / 20) * 10);
    const degrees = (scoreOutOf10 / 10) * 360;

    return `
    <div class="score-circle-wrapper">
        <div class="score-circle" style="--deg:${degrees}deg">
            <div class="score-inner">
                ${scoreOutOf10}<span>/10</span>
            </div>
        </div>
    </div>`;
};



export const generateContent = (interviewState) => {
    return `<!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Final Interview Report</title>
                <style>
                    body{
                        font-family: "Roboto", sans-serif;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 1.6;
                        margin: 0;
                        color: #000000;
                        background-color: #ffffff !important;
                        -webkit-font-smoothing: antialiased;
                        letter-spacing: 0;
                        padding: 8px;
                    }
                    a, a:hover, a:focus, button, button:hover, button:focus {
                        color: #746D6F;
                        text-decoration: none;
                        cursor: pointer;
                    }
                    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, b, strong {
                        font-family: "Roboto", sans-serif;
                        color: #000000;
                        font-weight: 600;
                        line-height: 1.1;
                    }
                    img {
                        max-width: 100%;
                    }
                    ul, ol {
                        margin: 0;
                        padding: 0;
                    }
                    li {
                        list-style: none;
                    }
                    .fir_header_wrap{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 90%;
                        margin: 0 auto 10px;
                        padding: 10px 0 10px 0;
                        flex-wrap: wrap;
                        page-break-after: avoid;
                        break-after: avoid;
                        page-break-inside: avoid;
                        border-bottom: 1px solid #000000;
                    }
                    .fir_header_left{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                    }
                    .fir_header_left h3{
                        margin: 0 0 5px 0;
                        font-size: 22px;
                    }
                    .fir_header_left ul{
                        display: flex;
                        flex-direction: column;
                        column-gap: 5px;
                    }
                    .fir_header_left ul li{
                        font-size: 14px;
                    }
                    .fir_header_center{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .fir_header_center button{
                        background-color: #00970F;
                        display: flex;
                        align-items: center;
                        height: 32px;
                        min-width: 83px;
                        border: 0;
                        justify-content: center;
                        border-radius: 50px;
                        color: #ffffff;
                    }
                    .fir_header_center p{
                        margin: 10px 0 0 0;
                        font-size: 12px;
                    }
                    .fir_header_center p span{
                        color: #F0DC96;
                    }
                    .fir_header_right{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        text-align: left;
                    }
                    .fir_header_right h3{
                        margin: 0 0 5px 0;
                        padding: 0;
                        font-size: 22px;
                        text-align: left;
                        word-break: break-word;
                        width: 100%;
                    }
                    .fir_header_right ul{
                        display: flex;
                        flex-direction: column;
                        column-gap: 5px;
                        margin: 0;
                        padding: 0;
                    }
                    .fir_header_right ul li{
                        font-size: 14px;
                        text-align: left;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        max-width: 100%;
                        white-space: normal;
                    }
                    .fir_heading_wrap{
                        position: relative;
                        z-index: 1;
                        display: flex;
                        width: 100%;
                        font-size: 12px;
                        margin: 10px 0;
                    }
                    .fir_heading_wrap span{
                        background-color: #ffffff;
                        position: relative;
                        z-index: 1;
                        padding-right: 10px;
                    }
                    .fir_heading_wrap::after{
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 50%;
                        background-color: #ffffff;
                        height: 2px;
                        width: 100%;
                    }
                    .fir_header_wrap .fir_heading_wrap{
                        margin-top: 10px;
                    }
                    .fir_main_wrap{
                        display: flex;
                        width: 90%;
                        margin: 0 auto;
                        flex-direction: column;
                        padding: 0 0 15px 0;
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                    .fir_main_wrap h2{
                        font-size: 22px;
                        margin: 0 0 10px 0;
                    }
                    .fir_section_wrap{
                        display: flex;
                        width: 100%;
                        flex-direction: column;
                        margin-bottom: 10px;
                        page-break-inside: avoid;
                        break-inside: avoid;
                        padding: 8px;
                    }
                    .fir_screenshot_section_wrap{
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 10px;
                        page-break-inside: avoid;
                        break-inside: avoid;
                        column-gap: 10px;
                        row-gap: 10px;
                    }
                    .fir_screenshot_section_wrap img{
                        width: calc((100% - 30px) / 4);
                        height: 100px;
                        min-height: 100px;
                        max-height: 100px;
                        object-fit: fill;
                        flex-shrink: 0;
                        display: block;
                    }
                    .fir_screenshot_section_wrap img.screenshot-full-width{
                        width: 100%;
                        height: 400px;
                        min-height: 400px;
                        max-height: 400px;
                        object-fit: fill;
                        margin-bottom: 10px;
                        display: block;
                    }
                    .fir_section_wrap ul{
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        margin-bottom: 15px;
                        font-size: 16px;
                        align-items: flex-start;
                        position: relative;
                    }
                    .fir_section_wrap ul li:first-child{
                        flex: 1;
                        padding-right: 20px;
                        min-width: 0;
                    }
                    .fir_section_wrap ul li:last-child{
                        flex-shrink: 0;
                        white-space: nowrap;
                        text-align: right;
                        min-width: 180px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        gap: 5px;
                    }
                    .fir_section_wrap p{
                        margin: 0 0 10px 0;
                    }
                    .fir_footer_wrap{
                        display: flex;
                        width: 100%;
                    }
                    .fir_footer_wrap ul{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        font-size: 14px;
                    }
                    .fir_footer_wrap ul li span{
                        color: #746D6F;
                    }
                    .fir_footer_wrap_logo{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .fir_footer_wrap_logo .rating-scale{
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        padding: 10px 20px;
                        margin-top: 10px;
                        gap: 20px;
                    }
                    .fir_footer_wrap_logo .rating-scale span{
                        white-space: nowrap;
                    }
                    .fir_skills_rating{
                        display: flex;
                        width: 100%;
                        margin: 0 0 15px 0;
                    }
                    .fir_skills_rating ul{
                        display: flex;
                        width: 100%;
                        justify-content: space-around;
                        align-items: center;
                        column-gap: 20px;
                    }
                    .fir_skills_rating ul li{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                    }
                    .fir_rating_box{
                        display: flex;
                        width: 100%;
                        flex-direction: column;
                        align-items: center;
                        background-color: #FFEDEA;
                        border-radius: 16px;
                        padding: 10px 0;
                        row-gap: 5px;
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                    .fir_rating_box p{
                        margin: 0;
                    }
                   
                    .coding_box {
                        display: flex;
                    }
                    .coding_child {
                        flex: 1;
                    }
                    .Poor, .Below-Average {
                        text-transform: uppercase; font-weight: bold; color: #790202; background:#F4BBBB; font-size: 12px; line-height: 12px; padding: 4px 8px; border-radius: 4px;"
                    }
                    .Average {
                        text-transform: uppercase; font-weight: bold; color: #832F00; background: #FFAD62; font-size: 12px; line-height: 12px; padding: 4px 8px; border-radius: 4px;"
                    }
                    .Good, .Very {
                        text-transform: uppercase; font-weight: bold; color: #00661D; background: #87FFA9; font-size: 12px; line-height: 12px; padding: 4px 8px; border-radius: 4px;"
                    }
                        .score-circle-wrapper {
    width: 110px;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.score-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: conic-gradient(
         #0f3b74 0deg var(--deg),
        #e6e6e6 var(--deg) 360deg
    );
    display: flex;
    justify-content: center;
    align-items: center;
}

.score-inner {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background:rgb(84, 85, 86);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.score-inner span {
    font-size: 12px;
    margin-left: 2px;
}

.profile-pic-oval {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

                    @media print {
                      @page {
                        margin: 0.5cm;
                      }
                      .fir_header_wrap {
                        page-break-after: avoid;
                        break-after: avoid;
                        page-break-inside: avoid;
                      }
                    }
                </style>
            </head>
            <body>
                <div class="fir_header_wrap">
                    <div class="fir_header_left">
                        <img src="${interviewState?.candidate_pic ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.candidate_pic}` : "/profile_pic.png"}" alt="Profile" class="profile-pic-oval" />
                    </div>
                    <div class="fir_header_center">
                    ${getOverallPercentageUI(interviewState)}
                        <button style="${interviewState ? `background-color: ${interviewState.final_status === INTERVIEW_FINAL_STATUS_SELECTED ? '#28a745' : '#dc3545'}; color: white; border: none; padding: 8px 12px; border-radius: 4px;` : ''}">${interviewState ? (interviewState.final_status === INTERVIEW_FINAL_STATUS_SELECTED ? 'Selected' : 'Rejected') : ""}</button>
                        <p><span>${interviewState && interviewState.report_date ? 'Report Sent : ' : ''}</span>${interviewState.report_date ? commonDateFormat(interviewState.report_date) : ""}</p>
                    </div>
                    <div class="fir_header_right">
                    ${interviewState && interviewState?.company && interviewState?.company?.profile_image
            ? `<img src="${process.env.REACT_APP_BUCKET_URL}${interviewState?.company?.profile_image}" alt="logo" width="100px" height="100px"/>`
            : ""}
                        <h3>${interviewState.candidate_name}</h3>
                        <ul>
                            <!-- <li>${interviewState.job.primary_skill.join(', ')}</li> -->
                            <li>${interviewState.candidate_email}</li>
                            <li>${interviewState.candidate_mobile_number}</li>
                        </ul>
                    </div>
                    <div class="fir_heading_wrap"><span></span></div>
                </div>
                <div class="fir_main_wrap">
                    <h2>Mandatory Skills</h2>
                    <div class="fir_section_wrap">
                        ${getPrimarySkillsUI(interviewState)}
                    </div>
                    <h2>Secondary Skills</h2>
                    <div class="fir_section_wrap">
                        ${getSecondarySkillsUI(interviewState)}
                    </div>
                    ${getGoodToHaveSkillsUI(interviewState) ? `<h2>Good to have Skills</h2><div class="fir_section_wrap">${getGoodToHaveSkillsUI(interviewState)}</div>` : ''}
                    ${getCodingSkillsUI(interviewState) ? `<h2>Coding Skills</h2><div class="fir_section_wrap">${getCodingSkillsUI(interviewState)}</div>` : ''}
                    ${getProfesstionalSkillsUI(interviewState) ? `<h2>Professional Skills</h2><div class="fir_section_wrap">${getProfesstionalSkillsUI(interviewState)}</div>` : ''}
                    <div class="fir_skills_rating">
                        <ul>
                            <li>
                                <div class="fir_rating_box">
                                    <p>${StarRating(5, interviewState ? interviewState.averagePrimarySkillsRating : 0)} </p>
                                    <span class=${getRatingStatus(interviewState.averagePrimarySkillsRating)}>${getRatingStatus(interviewState ? interviewState.averagePrimarySkillsRating : 0)}</span>
                                </div>
                                <p>Primary Skills</p>
                            </li>
                            <li>
                                <div class="fir_rating_box">
                                    <p>${StarRating(5, interviewState ? interviewState.averageSecondarySkillsRating : 0)}</p>
                                    <span class=${getRatingStatus(interviewState.averageSecondarySkillsRating)}>${getRatingStatus(interviewState ? interviewState.averageSecondarySkillsRating : 0)}</span>
                                </div>
                                <p>Secondary Skills</p>
                            </li>
                            <li>
                                <div class="fir_rating_box">
                                    <p>${StarRating(5, interviewState ? interviewState.coding_skill_feedback_rating : 0)}</p>
                                    <span class=${getRatingStatus(interviewState.coding_skill_feedback_rating)}>${getRatingStatus(interviewState ? interviewState.coding_skill_feedback_rating : 0)}</span>
                                </div>
                                <p>Coding</p>
                            </li>
                            <li>
                                <div class="fir_rating_box">
                                    <p>${StarRating(5, interviewState ? interviewState.overall_rating : 0)}</p>
                                    <span class=${getRatingStatus(interviewState.overall_rating)}>${getRatingStatus(interviewState ? interviewState.overall_rating : 0)}</span>
                                </div>
                                <p>Overall</p>
                            </li>
                        </ul>
                    </div>
                    <h2>Final Recommendation</h2>
                    <div class="fir_section_wrap">
                        ${interviewState.final_recommendation}
                    </div>
                    <div><span>Coding Test</span></div>
                    <div style="padding:1em; width:100%;margin:1em 0; background-color:#d0d3eb;">
                   <div style="padding:1em 0;">Question By Interviwer</div>
                    ${interviewState?.coding_questions.trim() !== ''
            ? `<div class="fir_section_wrap">${interviewState.coding_questions}</div>`
            : ''
        }
        </div>
        <div"><span>Code By Candidate</span></div>
        ${getCodingUI(interviewState)}
        <div style="font-weight:bold; margin:2em 0;">Uploaded Screenshot</div>
                     <div class="fir_screenshot_section_wrap">
                        ${getUploadedScreenshotUI(interviewState)}
                    </div>
                    <div class="fir_heading_wrap"><span></span></div>
                    <div class="fir_footer_wrap">
                        <ul>
                            <li><span>Interviewer:</span> ${interviewState ? interviewState.interviewInfo.first_name : ""}</li>
                            <li><span>Scheduled Date :</span> ${interviewState ? commonDateFormat(interviewState.scheduled_on) : "not scheduled yet"}</li>
                           <!-- <li><span>mandatory Skills :</span>  ${interviewState ? interviewState.job.primary_skill.join(', ') : ""}</li> -->
                        </ul>
                        </div>
                        <div class="fir_footer_wrap_logo">
                        <img src="/rala_infotech_color.svg" alt="logo" width="100px" height="100px"/>
                        <div class="rating-scale">
                            <span><b>Very Poor</b>: ≤2</span>
                            <span><b>Poor</b>: 3 to 4</span>
                            <span><b>Average</b>: 5</span>
                            <span><b>Above Average</b>: 6</span>
                            <span><b>Good</b>: 7</span>
                            <span><b>Very Good</b>: 8</span>
                            <span><b>Excellent</b>: ≥9</span>
                        </div>
                        </div>
                </div>
            </body>
            </html>`;
}